import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../hoc/compose';
import commonPropTypes from '../common/propTypes';
import displayNames from './displayNames';
import TextInputMultiline from './textInputMultiline';
import Button from './button';

var TextInputMultilineWithButton = /*#__PURE__*/function (_React$Component) {
  _inherits(TextInputMultilineWithButton, _React$Component);

  var _super = _createSuper(TextInputMultilineWithButton);

  function TextInputMultilineWithButton(props) {
    var _this;

    _classCallCheck(this, TextInputMultilineWithButton);

    _this = _super.call(this, props);
    _this.state = {
      isInputFocused: false
    };

    _this.onInputFocus = function () {
      _this.setState({
        isInputFocused: true
      });

      if (_.isFunction(_this.props.onFocus)) {
        _this.props.onFocus();
      }
    };

    _this.onInputBlur = function () {
      _this.setState({
        isInputFocused: false
      });

      if (_.isFunction(_this.props.onBlur)) {
        _this.props.onBlur();
      }
    };

    _this.getInputProps = function () {
      return _.assign({}, _this.props, {
        onBlur: _this.onInputBlur,
        onFocus: _this.onInputFocus
      });
    };

    return _this;
  }

  _createClass(TextInputMultilineWithButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-text-input-multiline-with-button'),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(TextInputMultiline, this.getInputProps()), this.state.isInputFocused ? /*#__PURE__*/React.createElement(Button, {
        key: "actionButton",
        className: 'btn-md' + ' ' + _({
          'btn-md': true,
          disabled: !this.props.value
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        disabled: !this.props.value
      }, this.props.buttonLabel) : null);
    }
  }]);

  return TextInputMultilineWithButton;
}(React.Component);

TextInputMultilineWithButton.displayName = displayNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON;
TextInputMultilineWithButton.propTypes = _.defaults({}, commonPropTypes.INPUT_PROP_TYPES, commonPropTypes.VALIDATED_PROP_TYPES, {
  buttonLabel: PropTypes.string.isRequired
});
export default compose(TextInputMultilineWithButton);